import React from 'react';
import { ActionButtonsProps } from '../types';
import { Check, X } from 'lucide-react';

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onKnown,
  onUnknown,
  disabled
}) => {
  return (
    <div className="flex items-center justify-center gap-4 mt-8">
      {/* "Neznám" Button - Left side, red theme with 3D border */}
      <button
        id="btn-dontknow"
        onClick={onUnknown}
        disabled={disabled}
        className={`
          flex items-center justify-center
          w-16 h-14 sm:w-20 sm:h-16 rounded-2xl font-bold text-white
          transition-all duration-150 transform
          ${disabled
            ? 'bg-gray-400 dark:bg-gray-600 cursor-not-allowed opacity-50 border-b-4 border-gray-500 dark:border-gray-700'
            : 'bg-red-500 hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-700 border-b-4 border-red-700 dark:border-red-800 hover:border-red-800 dark:hover:border-red-900 active:border-b-0 active:translate-y-[4px] shadow-lg hover:shadow-xl'
          }
        `}
        aria-label="Označit kartu jako neznámou"
      >
        <X className="w-6 h-6 sm:w-8 sm:h-8" strokeWidth={3} />
      </button>

      {/* "Znám" Button - Right side, green theme with 3D border */}
      <button
        id="btn-know"
        onClick={onKnown}
        disabled={disabled}
        className={`
          flex items-center justify-center
          w-16 h-14 sm:w-20 sm:h-16 rounded-2xl font-bold text-white
          transition-all duration-150 transform
          ${disabled
            ? 'bg-gray-400 dark:bg-gray-600 cursor-not-allowed opacity-50 border-b-4 border-gray-500 dark:border-gray-700'
            : 'bg-green-500 hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-700 border-b-4 border-green-700 dark:border-green-800 hover:border-green-800 dark:hover:border-green-900 active:border-b-0 active:translate-y-[4px] shadow-lg hover:shadow-xl'
          }
        `}
        aria-label="Označit kartu jako známou"
      >
        <Check className="w-6 h-6 sm:w-8 sm:h-8" strokeWidth={3} />
      </button>
    </div>
  );
};

export default ActionButtons;
